module.exports = new __parcel__URL__("untitled-goose-game.a75ff61d.jpg").toString();